const isParameterEmpty = (parameter) =>
  typeof parameter === "undefined" || parameter === null || parameter === "";

export default isParameterEmpty;
